import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  hrApi,
  type CreateEmployeePayload,
  type EmployeeQuery,
  type UpdateEmployeePayload,
} from '@/api/hr';

const EMPLOYEES_KEY = ['hr', 'employees'] as const;

export const useEmployees = (query: EmployeeQuery = {}) =>
  useQuery({
    queryKey:  [...EMPLOYEES_KEY, query],
    queryFn:   () => hrApi.getEmployees(query),
    staleTime: 60_000,
  });

export const useCreateEmployee = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (payload: CreateEmployeePayload) => hrApi.createEmployee(payload),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: EMPLOYEES_KEY });
      qc.invalidateQueries({ queryKey: ['finance', 'kpis'] }); // effectif est un KPI
    },
  });
};

export const useUpdateEmployee = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, payload }: { id: string; payload: UpdateEmployeePayload }) =>
      hrApi.updateEmployee(id, payload),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: EMPLOYEES_KEY });
      qc.invalidateQueries({ queryKey: ['finance', 'kpis'] });
    },
  });
};
